var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(this.$store.getters.isLoggedIn)?_c('div',[_c('h2',[_vm._v("Hello "+_vm._s(this.$store.getters.getUser.first_name)+"!")]),_c('p',[_vm._v("You are successfully logged in.")])]):_c('div',[_c('LoginForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }